import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Form from '../../../common/Form';
import { closeModalAction } from '../../../actions/modal';
import { addMembersInChat } from '../../../actions/chat';
import Users from '../../../components/Inputs/Users';


const formName = 'addMembersInChat';

export default function AddMembers({ conversationId, members, org_id }) {
    const methods = useForm({ mode: 'all' });
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const filter = useMemo(() => {
        return members.map((member) => (member.id));
    }, [members]);

    const onSubmit = (form) => {
        const userIds = form.members.map((member) => member.value);
        let payload = {
            members: userIds.map(userId => ({
                user_id: userId,
                role: "MEMBER"
            }))
        }
        dispatch(addMembersInChat({ payload, id: conversationId, formName }))
    };


    return (
        <Form
            methods={methods}
            onSubmit={onSubmit}
            showSubmit
            submitButtonText='Add'
            submitContainerClassName='flex justify-end gap-4 mt-8 mb-4 mr-4'
            onCancel={() => dispatch(closeModalAction())}
            isLoading={formButtonLoading[formName]}
        >
            <div className='px-4 pt-4'>
                <Users org_id={org_id} isMulti name='members' label='Add Members' required={true} filter={filter} />
            </div>
        </Form>
    );
}
